<template>
  <v-dialog>
    <v-card>
      <v-card-title>Informação</v-card-title>
      <v-card-text>
        {{ text }}
      </v-card-text>
      <v-card-action>
        <v-spacer></v-spacer>
        <v-btn text color="success">Continuar</v-btn>
      </v-card-action>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "TutorialDialog",
  props: {
    text: String
  }
}
</script>